<template>
  <div class="view content">
    <div class="news-page">
      <div class="news-header">
        <div class="line date">{{ $utils.formatDate(news.publishedAt) }}</div>
        <div class="line title" v-html="news.title" />
        <div class="line resume" v-html="news.resume" />
      </div>

      <div class="image-container">
        <div class="back-link" @click="_ => $router.push({ name: 'news' })">
          <div class="icon-container">
            <div class="icon-chevron left grey" />
          </div>
          <span>Retour aux actualités</span>
        </div>
        <div class="image-content" :style="`background: url(${news.imageUrl}) #B4C1D0;`"></div>
      </div>

      <div class="news-content">
        <div class="share-content">
          <span>partager l'article</span>
          <div class="external">
            <div class="cicle facebook">F</div>
            <div class="cicle twitter">G</div>
            <div class="cicle linkedin">In</div>
          </div>
        </div>
        <div class="content" v-html="news.content" />
      </div>

      <div class="see-more-container">
        <div class="header">
          <span>Autres actualités</span>
          <div class="main-button hide-small" @click="$router.push({ name: 'news' })">Toutes les actualités</div>
        </div>
        <News :news="otherNews.filter(x => x.publicId !== news.publicId)" vertical />
        <div class="main-button show-small" @click="$router.push({ name: 'news' })">Toutes les actualités</div>
      </div>
    </div>
  </div>
</template>

<script>
import News from '@/components/News';

export default {
  components: { News },

  data: function () {
    return {
      otherNews: [],
      news: {},
    };
  },

  watch: {
    $route({ params }) {
      const { id } = params;
      this.news = this.otherNews.find(x => x.publicId === id);
    },
  },

  async mounted() {
    const { id } = this.$route.params;

    this.otherNews = (await this.$store.dispatch('getNews')).items;
    this.news = this.otherNews.find(x => x.publicId === id);

    if (!this.news) this.$router.push('/news');
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
.view {
  margin-top: 90px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 21px;
  width: 21px;
}

.news-page {
  display: flex;
  flex-direction: column;
  align-items: center;

  .news-header {
    max-width: 794px;
    width: 100%;
    margin-top: 64px;
  }

  .image-container {
    width: 997px;
    margin-top: 16px;

    .back-link {
      margin: 18px 0;

      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      text-decoration-line: underline;

      color: colors.$lightgrey-color;

      cursor: pointer;
    }

    .image-content {
      height: 460px;
      width: 997px;

      // background: url(https://www.pythoncircle.com/media/uploads/desktop-wallpaper-change-python-20190823-d0843f2cd287490f8e1eeaa712e0f689.jpeg) $lightgrey-color;
      background-size: cover !important;
      background-position-x: center !important;
      background-position-y: center !important;
      background-repeat: no-repeat !important;
    }
  }

  .see-more-container {
    display: flex;
    flex-direction: column;

    max-width: 794px;
    // max-width: 997px;
    width: 100%;

    margin-top: 76px;

    span {
      font-weight: 500;
      font-size: 22px;
      line-height: 26px;

      color: colors.$darkblue-color;
    }

    .header {
      margin-bottom: 8px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  .news-content {
    max-width: 796px;
    width: 100%;

    padding: 80px 0;
    border-bottom: 1px solid #e1e5ea;

    display: flex;
    flex-direction: row;

    font-size: 15px;
    line-height: 20px;

    :deep(.content) {
      margin-left: 48px;

      a {
        color: colors.$blue-color;
        text-decoration: underline;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: colors.$darkblue-color;
        }
      }

      .video-media {
        margin-top: 40px;
        width: 100%;
        aspect-ratio: 16/9;
        min-height: 300px;
      }
    }
  }

  .share-content {
    min-width: 158px;

    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: colors.$lightgrey-color;

    .external {
      display: flex;
      flex-direction: row;

      justify-content: space-between;

      margin: 18px 0;
    }

    .cicle {
      display: flex;
      align-items: center;
      justify-content: center;

      color: white;

      height: 35px;
      width: 35px;
      border-radius: 100%;
      background: colors.$green-color;

      cursor: pointer;
    }
  }

  .line {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    color: colors.$black-color;

    margin: 6px 0;

    &.date {
      font-size: 11px;
      line-height: 13px;
      color: colors.$grey-color;
    }

    &.title {
      font-size: 30px;
      line-height: 32px;
      color: colors.$green-color;
    }

    &.resume {
      margin: 16px 0;
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .view {
    overflow: hidden;
  }

  .news-content {
    flex-direction: column !important;
    align-items: center !important;

    padding-top: 36px !important;

    .share-content {
      width: 186px !important;
      margin-bottom: 16px;
    }

    .content {
      margin-left: 0 !important;
      padding-left: 0;
    }
  }

  .image-container {
    width: 110% !important;

    .back-link {
      margin-left: 16px !important;
    }

    .image-content {
      width: 100% !important;
      height: 256px !important;
    }
  }
}
</style>
